module.exports = __webpack_public_path__ + "static/media/logo-skillacademy-right.a14149bb.png";